import classNames from 'classnames';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';
import { ReactComponent as SamadLogo } from '@/assets/images/logo-samad-colored.svg';
import Flex from '../Flex';

import './styles.css';

export interface PaymentCardProps {
  hintText?: string;
  hintTextColor?: string;
  valueText?: string;
  valuePostfix?: string;
  textColor?: string;
  cardNumber?: string;
  cardOwnerText?: string;
  className?: string;
}

export function PaymentCard({
  hintText = undefined,
  hintTextColor = '#4C8251',
  valueText = undefined,
  valuePostfix = undefined,
  textColor = '#fff',
  cardNumber = '000000000',
  cardOwnerText = '',
  className = ''
}: PaymentCardProps) {

  const [t] = useTranslation(['common']);

  if (!valuePostfix) {
    valuePostfix = envConfig.ui.removeCurrency ? '' : t('common:labels.tomans');
  }
  if (!hintText) {
    valuePostfix = t('common:labels.wallet');
  }

  return (
    <Card className={classNames('payment-card', className)}>
      <Flex className="w-full" direction="column">
        <span style={{ color: hintTextColor }} className="hint-text">{hintText}</span>
        <Flex align="center" className="font-bold" style={{ color: textColor }}>
          <span className="text-2xl font-sans">{valueText}</span>
          <span className="text-base">{valuePostfix}</span>
        </Flex>
        <Flex align="center" className="w-full pt-2" direction="row">
          <SamadLogo className="samad-card-logo" style={{ width: '48px', height: '48px', color: 'red' }} />
          <Flex direction="column" align="flex-end" className="ms-auto font-medium" style={{ color: textColor }}>
            <span style={{ letterSpacing: '1px' }}>{cardNumber}</span>
            <span>{cardOwnerText}</span>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}

export default PaymentCard;
